// src/services/endpoints.ts
export const API_ENDPOINTS = {
  USERS: '/users',
  POSTS: '/posts',
  ONBOARDING: '/AdminManagement/clientOnboarding',
  ADMIN: '/AdminManagement/admin',
  DATABASE: '/AdminManagement/clientOnboarding/databases',
  /** Batch Scheduling (admin): job types, schedules, assignments, blackouts, executions. */
  BatchExecutions: '/AdminManagement/batch-executions',
  BatchSchedules: '/AdminManagement/batch-schedules',
  BatchAssignments: '/AdminManagement/batch-assignments',
  BlackoutDates: '/AdminManagement/blackout-dates',
  JobTypes: '/AdminManagement/job-types',
  /** Batch Scheduling's slim tenant picker — id, name, active flag. */
  TenantLookup: '/AdminManagement/tenants',
  PARAMETERS: '/AwardManagement/parameters',
  TENANT: '/AwardManagement/user',
  UserGroup: '/AwardManagement/usergroup',
  MAINTENANCE: '/AwardManagement/maintenance',
  MASTER: '/AwardManagement/master',
  TEMPLATE: '/AwardManagement/template',
  AWARD: '/AwardManagement/manageaward',
  AwardList: '/AwardManagement/awardlist',
  AwardLetter: '/AwardManagement/awardletter',
  fileUpload: '/AwardManagement/fileUpload',
  VIEW: '/AwardManagement/viewaward',
  FINALAWARD: '/AwardManagement/finalaward',
  SHARECREDIT: '/AwardManagement/share-crediting',
  CREDITDETAILS: '/AwardManagement/crediting-details',
  PERSONALLEDGER: '/AwardManagement/personal-ledger',
  ROUNDINGPOLICY: '/AwardManagement/ManageRoundingPolicy',
  AWARDGOVERNANCE: '/AwardManagement/awardgovernance',
  /** Help & Tours plan documents (FAQ upload/download per plan). */
  PLANDOCUMENTS: '/AwardManagement/plan-documents',
  REPORT: '/Report',
  /** Background report runs sit outside the /Report namespace. */
  REPORTBACKGROUND: '/report-background',
  /** Report catalog (the Reports landing) under AwardManagement. */
  REPORTCATALOG: '/AwardManagement/report-catalog',
  /** Report definitions (custom report preview) under AwardManagement. */
  REPORTDEFINITIONS: '/AwardManagement/report-definitions',
  /** Tenant-wide display settings (date / time format) for the logged-in tenant. */
  TENANTSETTINGS: '/AwardManagement/tenant-settings',
};
